import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const fetchFeatureModel = createAsyncThunk(
	'featureModel/featureModelLoading',
	 (options, {getState}) => superagent
			.get(`${getState().status.engineUrl}/session/meta/featuremodel/`)
			.set('X-SESSION-ID', getState().session.sessionId)
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);

export const featureModelSlice = createSlice({
	name: 'featureModel',
	initialState: {
		status: 'idle',
		data: {},
		error: {},
	},
	reducers: {
		setFeatureModel: (state, action) => {
			state.data = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchFeatureModel.fulfilled, (state, action) => {
			state.data = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchFeatureModel.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchFeatureModel.rejected, (state, action) => {
			state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});

export const {
	setFeatureModel
} = featureModelSlice.actions;


export default featureModelSlice.reducer;
